import { render, staticRenderFns } from "./SidebarEditProfile.vue?vue&type=template&id=2adf1aa2&scoped=true"
import script from "./SidebarEditProfile.vue?vue&type=script&lang=js"
export * from "./SidebarEditProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditProfile.vue?vue&type=style&index=0&id=2adf1aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf1aa2",
  null
  
)

export default component.exports